module.exports = __webpack_public_path__ + "img/rheinland_pfalz_mobiportal.f0f46525.png";